import { useField } from "formik";
import { FusionMelcoModelsUserImage } from "melco-shared-logic";

export const useBlankPictureByIdFromProduct = (blankPictureId: string) => {
  const [{ value: blankPictures }] = useField<
    FusionMelcoModelsUserImage[] | undefined
  >("blank.images");

  return (blankPictures ?? []).find((bp) => bp.id === blankPictureId);
};
